import SplitEqual from "@assets/splitEqual.png";
import ResetIcon from "@assets/ResetIcon.svg";
import Tooltip from "@/components/Common/Tooltip";

type ButtonConfig = {
  label: string;
  icon: string;
  onClick: () => void;
  tooltipText: string;
};

export const AllocationControls = ({
  onSplit,
  onReset,
  hideSplitButton = false,
  splitTooltipText,
  resetTooltipText,
}: {
  onSplit: () => void;
  onReset: () => void;
  splitTooltipText: string;
  resetTooltipText: string;
  hideSplitButton?: boolean;
}) => {
  const buttons: ButtonConfig[] = [
    !hideSplitButton
      ? {
          label: "Split equal",
          icon: SplitEqual,
          onClick: onSplit,
          tooltipText: splitTooltipText,
        }
      : null,
    !hideSplitButton
      ? {
          label: "Reset",
          icon: ResetIcon,
          onClick: onReset,
          tooltipText: resetTooltipText,
        }
      : null,
  ].filter((btn): btn is ButtonConfig => btn !== null);

  return (
    <div className="flex space-x-4">
      {buttons.map(({ label, icon, onClick, tooltipText }) => (
        <div key={label} className="flex items-center space-x-1">
          <button
            onClick={onClick}
            className="text-[#00ADAC] h-full flex space-x-2 items-center"
          >
            <img src={icon} className="h-[18px]" alt={label} />
            <span className="hidden md:block">{label}</span>
          </button>
          <span className="text-[18px]">
            <Tooltip text={tooltipText} />
          </span>
        </div>
      ))}
    </div>
  );
};
